import React, { useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const meterDigits = 4; // Adjust if your lucky numbers have a different length

const WinnerReveal = () => {
  const [revealed, setRevealed] = useState(false);
  const [prizes, setPrizes] = useState([]);
  const [rolling, setRolling] = useState(false);
  const [displayNumbers, setDisplayNumbers] = useState([]);

  // Animation function for all prizes
  const rollAnimation = (finalPrizes) => {
    setRolling(true);
    let count = 0;
    const interval = setInterval(() => {
      setDisplayNumbers(
        finalPrizes.map(() =>
          String(Math.floor(Math.random() * Math.pow(10, meterDigits))).padStart(meterDigits, '0')
        )
      );
      count++;
      if (count > 30) {
        clearInterval(interval);
        setDisplayNumbers(finalPrizes.map(prize => String(prize.lucky_number).padStart(meterDigits, '0')));
        setRolling(false);
        setRevealed(true);
      }
    }, 60);
  };

  const handleReveal = async () => {
    setRolling(true);
    setRevealed(false);
    setPrizes([]);
    setDisplayNumbers([]);
    // Fetch winner/prizes from backend
    const res = await axios.get(`${API_BASE_URL}/winner`);
    setPrizes(res.data.prizes);
    rollAnimation(res.data.prizes);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-900 to-indigo-700">
      <h1 className="text-4xl font-extrabold text-white mb-8 drop-shadow-lg">🎉 Lucky Draw Winner Reveal 🎉</h1>
      <div className="bg-black rounded-2xl shadow-2xl p-10 flex flex-col items-center">
        {prizes.length > 0 && (
          <div className="space-y-4 mb-6">
            {prizes.map((prize, idx) => (
              <div key={idx} className="flex items-center gap-4">
                <span className="text-white text-2xl font-bold w-16">{prize.tier}</span>
                <span className="flex space-x-2">
                  {(displayNumbers[idx] || '00000').split('').map((digit, i) => (
                    <span
                      key={i}
                      className="bg-gray-900 text-lime-400 font-mono text-5xl rounded-lg px-3 py-1 border-4 border-lime-400 shadow-lg"
                      style={{ minWidth: '40px', textAlign: 'center' }}
                    >
                      {digit}
                    </span>
                  ))}
                </span>
                <span className="text-lime-300 text-xl font-semibold ml-4">Points: {prize.points}</span>
              </div>
            ))}
          </div>
        )}
        <button
          className={`px-8 py-3 rounded-lg text-xl font-bold shadow-lg transition-all ${
            rolling
              ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
              : 'bg-gradient-to-r from-lime-400 to-green-500 text-black hover:from-green-400 hover:to-lime-500'
          }`}
          onClick={handleReveal}
          disabled={rolling}
        >
          {rolling ? 'Revealing...' : 'Reveal Winner'}
        </button>
        {revealed && (
          <div className="mt-8 text-center text-white text-2xl font-bold">
            🎊 Congratulations to all the winners!
          </div>
        )}
      </div>
    </div>
  );
};

export default WinnerReveal;